import { useQuery } from "@tanstack/react-query";
import { fetchPrice } from "@/services/real";
import { useWalletClient } from "wagmi";
import type { TokenId } from "@/types";

export function usePriceStore(unit: TokenId) {
    const { data: walletClient } = useWalletClient();

    const { data: price, isLoading } = useQuery({
        queryKey: ["price", unit],
        queryFn: () => fetchPrice(unit, walletClient),
    });

    return { price, isLoading };
}
